import { createFileRoute, redirect } from '@tanstack/react-router';

/** `/reports` has no content of its own; Delivery is the landing dashboard (§10.2). */
export const Route = createFileRoute('/reports/')({
  beforeLoad: () => {
    throw redirect({ to: '/reports/$dashboard', params: { dashboard: 'delivery' } });
  },
});
